import * as UserConstants from '../../action/user/UserConstants';

const initialState = {
  userStatisticData: [],
  userStatisticDataIsFetching: false,
  userStatisticDataErrorMessage: '',
  loggedUserStatisticData: [],
  loggedUserStatisticDataIsFetching: false,
  loggedUserStatisticDataErrorMessage: '',
  allUsersStatisticData: [],
  allUsersStatisticDataIsFetching: false,
  allUsersStatisticDataErrorMessage: ''
};

export const userStore = (state = initialState, action) => {
  switch (action.type) {
    case UserConstants.GET_USER_STATISTIC_DATA_BY_ID_REQUEST:
      return {
        ...state,
        userStatisticDataIsFetching: true,
        userStatisticDataErrorMessage: ''
      };
    case UserConstants.GET_USER_STATISTIC_DATA_BY_ID_SUCCESS:
      return {
        ...state,
        userStatisticDataIsFetching: false,
        userStatisticData: action.data
      };
    case UserConstants.GET_USER_STATISTIC_DATA_BY_ID_FAILED:
      return {
        ...state,
        userStatisticDataIsFetching: false,
        userStatisticDataErrorMessage: action.error.message
        // userStatisticDataErrorMessage: 'SERVER ERROR',
      };
    case UserConstants.GET_USER_STATISTIC_DATA_BY_ID_CLEAR:
      return {
        ...state,
        userStatisticDataIsFetching: false,
        userStatisticData: [],
        userStatisticDataErrorMessage: ''
      };

    case UserConstants.GET_LOGGED_USER_STATISTIC_DATA_REQUEST:
      return {
        ...state,
        loggedUserStatisticDataIsFetching: true,
        loggedUserStatisticDataErrorMessage: ''
      };
    case UserConstants.GET_LOGGED_USER_STATISTIC_DATA_SUCCESS:
      return {
        ...state,
        loggedUserStatisticDataIsFetching: false,
        loggedUserStatisticData: action.data
      };
    case UserConstants.GET_LOGGED_USER_STATISTIC_DATA_FAILED:
      return {
        ...state,
        loggedUserStatisticDataIsFetching: false,
        loggedUserStatisticDataErrorMessage: action.error.message
        //loggedUserStatisticDataErrorMessage: 'SERVER ERROR',
      };
    case UserConstants.GET_LOGGED_USER_STATISTIC_DATA_CLEAR:
      return {
        ...state,
        loggedUserStatisticDataIsFetching: false,
        loggedUserStatisticData: [],
        loggedUserStatisticDataErrorMessage: ''
      };

    case UserConstants.GET_ALL_USERS_STATISTIC_DATA_REQUEST:
      return {
        ...state,
        allUsersStatisticDataIsFetching: true,
        allUsersStatisticDataErrorMessage: ''
      };
    case UserConstants.GET_ALL_USERS_STATISTIC_DATA_SUCCESS:
      return {
        ...state,
        allUsersStatisticDataIsFetching: false,
        allUsersStatisticData: action.data
      };
    case UserConstants.GET_ALL_USERS_STATISTIC_DATA_FAILED:
      return {
        ...state,
        allUsersStatisticDataIsFetching: false,
        allUsersStatisticDataErrorMessage: action.error.message
        //allUsersStatisticDataErrorMessage: 'SERVER ERROR',
      };
    case UserConstants.GET_ALL_USERS_STATISTIC_DATA_CLEAR:
      return {
        ...state,
        allUsersStatisticDataIsFetching: false,
        allUsersStatisticData: [],
        allUsersStatisticDataErrorMessage: ''
      };

    default:
      return state;
  }
};
